import React from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalContent,
  Button,
} from "@nextui-org/react";

const PaymenetModal = ({ isOpen, onClose, onConfirm, paymentMethod }) => {
  return (
    <>
      <Modal
        size="sm"
        isOpen={isOpen}
        onClose={onClose}
        className="p-3"
        placement="center"
      >
        <ModalContent>
          <ModalBody>
            <p className="text-center capitalize">
              Are You Sure You Want To Confirm The Payment?
              <br />
              <span className="block mt-1 font-bold">
                PaymentMethod:-{" "}
                <span className="font-bold text-blue-600">
                  {paymentMethod || "N/A"}
                </span>
              </span>
            </p>
          </ModalBody>
          <ModalFooter className="flex justify-center gap-4">
            <Button
              color="primary"
              onPress={() => {
                onConfirm();
                onClose();
              }}
            >
              Yes
            </Button>
            <Button color="danger" variant="light" onPress={onClose}>
              No
            </Button>
            {/* <Button color="primary" onPress={onConfirm}>
              Yes
            </Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PaymenetModal;
